// ----------------------------------------------------------------------
import type { Components, Theme } from "@mui/material"

export default function Stepper(theme: Theme) {
  const data: Components = {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        text: {
          fill: theme.palette.grey[100],
        },
      },
    },
  }
  return data
}
